<template lang="pug">
.checkin-modal-container(v-if="show", @touchmove.prevent)
  img.light(
    src="https://m.hellobike.com/resource/AppPlatformH5/fuli/asDuEbp0aP83sAXOg6hCp.png"
  )
  .body
    .title 获得奖励金{{ total }}个，明天记得再来哦～
    .coins
      .coin-item(v-if="coins[0]")
        .top.flex-mid
          img(
            src="https://m.hellobike.com/resource/AppPlatformH5/fuli/28NOSshWZGY6X5IBwRbu9.png"
          )
          span.amount(
            :class="[coins[0].amount.length ? 'length-' + coins[0].amount.length : '']"
          )
            span.add +
            span {{ coins[0].amount }}
        .bottom {{coins[0].name}}
      template(v-if="coins[1]")
        .plus +
        .coin-item
          .top.flex-mid
            img(
              src="https://m.hellobike.com/resource/AppPlatformH5/fuli/28NOSshWZGY6X5IBwRbu9.png"
            )
            span.amount(
              :class="[coins[1].amount.length ? 'length-' + coins[1].amount.length : '']"
            ) +{{ coins[1].amount }}
          .bottom {{coins[1].name}}
    .btn.flex-mid(@click="close") 立即收下
    .modal-close(@click="close")
  .shadow
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { add } from '../../../utils';
import { ParamsUtil } from '../../../utils/params';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    coins: {
      type: Array,
      default: null,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    total() {
      const [a, b] = this.coins;
      if (this.coins.length === 0) {
        return '0';
      } if (this.coins.length === 1) {
        return a.amount;
      }
      return add(a.amount, b.amount || 0);
    },
  },
  methods: {
    close() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'sign_Popup',
        categoryId: 'platform',
        businessInfo: {
          day: `${this.activeIndex + 1}`,
          adsource: ParamsUtil.getParam('adsource'),
        },
      });
      this.$emit('close');
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.checkin-modal-container {
  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }

  .modal-close {
    margin: 0;
    display: block;
    position: fixed;
    top: 0.14rem;
    right: 0.14rem;
    width: 0.2rem;
    height: 0.2rem;
    z-index: 2000;

    &::before,
    &::after {
      content: " ";
      display: block;
      position: absolute;
      top: 0.04rem;
      right: -0.02rem;
      width: 0.16rem;
      height: 2px;
      transform: translateY(-50%) rotate(45deg);
      background-color: #bcc4cc;
      border-radius: 4px;
    }

    &::after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }

  .body {
    width: 3.2rem;
    height: 3.02rem;
    background: #fff;
    border-radius: 12px;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    z-index: 110;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 44%;
    padding: 0.5rem 0 0.3rem;

    .title {
      font-size: 0.15rem;
      font-weight: 500;
      color: #242729;
    }

    .plus {
      font-size: 0.24rem;
      margin: 0.2rem 0.12rem 0;
      font-family: "DIN Alternate Bold", sans-serif;
      font-weight: bold;
      color: #d4d4d4;
    }

    .coins {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .coin-item {
      display: flex;
      flex-direction: column;
      width: 0.8rem;

      .bottom {
        font-size: 0.15rem;
        font-weight: 600;
        color: #879099;
        text-align: center;
        // white-space: nowrap;
      }

      .top {
        position: relative;
        margin-bottom: 0.11rem;

        img {
          width: 0.6rem;
          height: 0.6rem;
        }

        .amount {
          font-family: "DIN Alternate Bold", sans-serif;
          text-shadow: 0 0 0 #c47e01;
          color: #fff9e1;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
          line-height: 1;

          .add {
            position: relative;
            top: -1px;
          }

          &.length-1 {
            font-size: 0.22rem;
          }

          &.length-2 {
            font-size: 0.2rem;
          }

          &.length-3 {
            font-size: 0.2rem;
          }

          &.length-4 {
            font-size: 0.16rem;
          }
        }
      }
    }

    .btn {
      width: 2.88rem;
      height: 0.48rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>
